module.exports = ".font-s80 {\r\n  font-size: 80px !important;\r\n}\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/coming-soon/coming-soon.component.css
// module id = ./src/app/components/coming-soon/coming-soon.component.css
// module chunks = main